import { PublicLayout } from "@/components/layout/PublicLayout";

const Impressum = () => {
  return (
    <PublicLayout
      showHero={true}
      heroTitle="Impressum"
      heroSubtitle="Rechtliche Informationen"
      heroVariant="compact"
    >
      <div className="container mx-auto px-4 py-16">
        <div className="prose max-w-4xl mx-auto">
          <div className="space-y-8">
            <div>
              <h2 className="text-xl font-bold mb-4">Saleway GmbH</h2>
              <div className="text-gray-700">
                <p>Schulhausgässli 4</p>
                <p>3098 Köniz</p>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Vertreten durch:</h2>
              <p className="text-gray-700">Pascal Schildknecht & Jens Neubeck</p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Kontakt:</h2>
              <div className="text-gray-700 space-y-2">
                <p><span className="font-medium">Telefon:</span> <a href="tel:+41315520702" className="text-blue-600 hover:text-blue-800">+41 31 552 07 02</a></p>
                <p><span className="font-medium">Telefax:</span> +41 76 379 00 00</p>
                <p><span className="font-medium">E-Mail:</span> <a href="mailto:info@salesangels.org" className="text-blue-600 hover:text-blue-800">info@salesangels.org</a></p>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Registereintrag:</h2>
              <div className="text-gray-700 space-y-2">
                <p>Eintragung im Handelsregister.</p>
                <p><span className="font-medium">Registergericht:</span> Bern</p>
                <p><span className="font-medium">Registernummer:</span> CH-036.4.066.369-4</p>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Mehrwertsteuer:</h2>
              <div className="text-gray-700">
                <p><span className="font-medium">Mehrwertsteuer-Identifikationsnummer:</span></p>
                <p>CHE-437.932.259</p>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-4">Streitschlichtung</h2>
              <p className="text-gray-700">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Impressum;